<ng-container *ngIf="templateData">
    <div class="process-indicator compact responsive has-labels">
        <span class="responsive-label"><span>{{'InProgress' | translate}}: </span>{{processIndicatorResponsiveDisplayData?.label}}</span>
        <div class="display">
            <div *ngFor="let data of templateData; index as i" class="step" [id]="data.htmlStepId">
                <span class="label" soho-tooltip title="{{data.label}}">{{data.label}}</span>
                <div class="lines">
                    <div class="indicator {{data.completionStatusInfo.indicatorClass}}" [ngClass]="{'icon': data.completionStatusInfo.iconInfo.icon}" soho-tooltip content="{{data | lmProcessIndicatorTooltip}}">
                        <svg *ngIf="data.completionStatusInfo.iconInfo.icon" soho-icon icon="{{data.completionStatusInfo.iconInfo.icon}}" class="{{data.completionStatusInfo.iconInfo.colorClass}}"></svg>
                    </div>
                    <span class="separator" [ngClass]="{'darker': (data.status === 'C' || data.status === 'X')}"></span>
                </div>
                <div class="details">
                    <ng-template *ngTemplateOutlet="Approvers; context:{data: data}"></ng-template>
                    <ng-template *ngTemplateOutlet="TimeStamp; context:{data: data}"></ng-template>
                </div>
            </div>
        </div>

        <!-- display this when phone size -->
        <div class="responsive-details details">
            <ng-template *ngTemplateOutlet="Approvers; context:{data: processIndicatorResponsiveDisplayData}"></ng-template>
            <ng-template *ngTemplateOutlet="TimeStamp; context:{data: processIndicatorResponsiveDisplayData}"></ng-template>
        </div>
    </div>
</ng-container>

<!-- shared templates -->
<ng-template #Approvers let-data=data>
    <span *ngIf="data?.status" class="heading">{{data.displayStatus}}</span>
    <ng-container *ngFor="let item of data?.stepApproversDisplay">
        <ng-template *ngTemplateOutlet="ApproverItem; context:{item: item}"></ng-template>
    </ng-container>
    <ng-container *ngIf="data?.stepApproversOverflowContextMenuItems">
        <a class="lm-more-approvers-link hyperlink" soho-context-menu attachToBody="false" [trigger]="'click'">more</a>
        <ul soho-popupmenu [id]="data.htmlStepOverflowId" class="approver-overflow-menu">
            <li soho-popupmenu-item *ngFor="let overflowItem of data.stepApproversOverflowContextMenuItems">
                <ng-template *ngTemplateOutlet="ApproverItem; context:{item: overflowItem}"></ng-template>
            </li>
        </ul>
    </ng-container>
</ng-template>

<ng-template #TimeStamp let-data=data>
    <span class="elapsed-time" *ngIf="data?.elapsedTime" soho-tooltip content="{{data.elapsedTimeToolTip}}">
        {{data.elapsedTime}}
    </span>
</ng-template>

<ng-template #ApproverItem let-item=item>
    <div class="item">
        <svg *ngIf="item?.icon" class="{{item.colorClass}}" soho-icon [icon]="item.displayIcon"></svg>
        <ng-container *ngIf="item?.email">
            <a class="hyperlink" href="mailto:{{item.email}}"><span>{{item.approver}}</span></a>
        </ng-container>
        <ng-container *ngIf="!item?.email">
            <span>{{item.approver}}</span>
        </ng-container>
        <ng-container *ngIf="item?.tag">
            <span [ngClass]="{'tag': item.tag, 'secondary': item.displayTag.type === 'secondary'}">{{item.displayTag.value}}</span>
        </ng-container>
    </div>
</ng-template>
